/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geoempty1Inputs */

const en_geoempty1 = /** @type {(inputs: Geoempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity recorded in this window yet. App opens start counting from the deploy onward.`)
};

const de_geoempty1 = /** @type {(inputs: Geoempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diesem Zeitraum noch keine Aktivität erfasst. App-Öffnungen werden ab dem Deploy gezählt.`)
};

/**
* | output |
* | --- |
* | "No activity recorded in this window yet. App opens start counting from the deploy onward." |
*
* @param {Geoempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geoempty1 = /** @type {((inputs?: Geoempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geoempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geoempty1(inputs)
	return de_geoempty1(inputs)
});
export { geoempty1 as "geoEmpty" }